var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.42,
    y: 286.45,
    width: 69.22,
    height: 55.34,
    transform: "translate(-56.65 17.31) rotate(-10.6)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,280.56l-.33.08-1,.19-3.69.72-13.93,2.67L26,293.52l.19-.28c3,16.19,6.52,34.75,10.21,54.39h0l-.31-.22,68-12.68-.17.26c-3-16.38-5.52-29.95-7.27-39.46-.86-4.75-1.54-8.48-2-11-.23-1.27-.4-2.24-.52-2.92s-.17-1-.17-1,.08.32.2,1l.57,2.87c.49,2.55,1.2,6.26,2.11,11,1.81,9.53,4.39,23.14,7.51,39.56l.05.21-.22.05L36.14,348l-.26.05-.05-.27h0c-3.66-19.64-7.13-38.2-10.15-54.4l0-.23.24-.05L75.16,284l13.89-2.54,3.67-.66.93-.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 289.94,
    width: 64.36,
    height: 48.37,
    transform: "translate(-56.65 17.3) rotate(-10.6)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.8 343.82 54.37 310.13 71.51 326.06 78.95 314.44 101.06 331.99 37.8 343.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.19,302.87a5.07,5.07,0,1,1-5.92-4.05A5.07,5.07,0,0,1,73.19,302.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.97,
    y: 89.38,
    width: 195.57,
    height: 144.8,
    transform: "translate(46.07 378.71) rotate(-79.74)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.57,270.89s.05-.32.15-.92l.48-2.71c.42-2.38,1.05-5.9,1.86-10.47,1.65-9.16,4.05-22.54,7.09-39.48l25-138.9.2.28L195.9,52.92h0l.31-.22c-13,71.79-25.07,138.29-34.89,192.43l-.17-.25,103.53,18.86L293.41,269l7.56,1.4c1.71.31,2.6.49,2.6.49l-2.56-.44-7.53-1.34L264.75,264l-103.7-18.66-.21,0,0-.21c9.79-54.16,21.82-120.66,34.8-192.45l0-.26.27,0h0L338.45,78.21l.24.05,0,.23c-10.37,57-19.13,105.13-25.29,139l-7.2,39.4c-.84,4.55-1.48,8-1.92,10.42-.22,1.17-.38,2.06-.49,2.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.69,
    y: 78.04,
    width: 61.48,
    height: 53.56,
    transform: "translate(22.41 -39.91) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.03,
    y: 89.12,
    width: 39.36,
    height: 6.99,
    transform: "translate(21.25 -51.38) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.71,
    y: 146.52,
    width: 112.34,
    height: 6.99,
    transform: "translate(30.75 -42.47) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.52,
    y: 158.63,
    width: 112.34,
    height: 6.99,
    transform: "translate(32.88 -41.89) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.33,
    y: 170.73,
    width: 112.34,
    height: 6.99,
    transform: "translate(35 -41.3) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.13,
    y: 182.84,
    width: 112.34,
    height: 6.99,
    transform: "translate(37.12 -40.72) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.94,
    y: 194.94,
    width: 112.34,
    height: 6.99,
    transform: "translate(39.24 -40.14) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.43,
    y: 236.44,
    width: 112.34,
    height: 6.99,
    transform: "translate(46.51 -38.13) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.16,
    y: 202.53,
    width: 61.67,
    height: 6.99,
    transform: "translate(40.16 -35.18) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.02,
    y: 100.25,
    width: 39.36,
    height: 6.99,
    transform: "translate(23.2 -50.84) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 111.38,
    width: 39.36,
    height: 6.99,
    transform: "matrix(0.98, 0.18, -0.18, 0.98, 25.15, -50.3)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.11,
    y: 121.16,
    width: 24.27,
    height: 6.99,
    transform: "translate(26.74 -48.47) rotate(10.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,51.76l-12.29.5-1.33,3.44a7.59,7.59,0,0,0-.6,2.83A2.32,2.32,0,0,0,355,60.64a10.09,10.09,0,0,0,3.44.47l0,1L347,62.53l0-1a5.17,5.17,0,0,0,3-1.68,20.43,20.43,0,0,0,2.77-5.36L364,26.27l.49,0,13.69,28q2,4,3.16,5a4,4,0,0,0,2.5.83l0,.94-16.83.68,0-.95.7,0a5.19,5.19,0,0,0,2.82-.68,1.34,1.34,0,0,0,.52-1.2,3.21,3.21,0,0,0-.19-.94c0-.15-.33-.79-.85-1.89Zm-.95-1.86-5.66-11.78-4.86,12.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.04,
    y: 132.61,
    width: 59.26,
    height: 47.38,
    transform: "translate(-30.42 125.46) rotate(-18.47)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 135.6,
    width: 55.09,
    height: 41.41,
    transform: "translate(-30.43 125.45) rotate(-18.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.06 184.67 361.16 154.16 377.56 165.66 382.5 154.93 403.31 167.22 351.06 184.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.26,145.79a4.34,4.34,0,1,1-5.49-2.74A4.33,4.33,0,0,1,376.26,145.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.11,
    y: 71.12,
    width: 71.59,
    height: 89.54,
    transform: "translate(233.54 515.51) rotate(-78.92)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.72,89.37l-.43-.07-1.24-.22-4.78-.91-18-3.46L392.8,72.4l.28-.19c-4.09,20.91-8.77,44.88-13.73,70.25h0l-.21-.32L467,159.41l-.26.17c4.19-21.14,7.66-38.67,10.09-50.92,1.23-6.13,2.19-10.94,2.85-14.23.33-1.64.58-2.89.76-3.76s.28-1.3.28-1.3-.07.43-.23,1.27-.39,2.1-.7,3.72c-.63,3.28-1.55,8.08-2.72,14.2-2.38,12.3-5.79,29.89-9.89,51.11l-.05.22-.21,0L379,142.68l-.26-.05.05-.26h0c5-25.36,9.69-49.33,13.79-70.24l.05-.24.23.05L456.47,84.5l17.92,3.58,4.73,1,1.2.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.56,
    y: 74.26,
    width: 62.57,
    height: 83.25,
    transform: "translate(233.51 515.44) rotate(-78.92)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.98 138.59 418.99 106.01 431.99 133.35 446.48 122.93 464.68 154.59 382.98 138.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.09,106.26a6.56,6.56,0,1,1-5.18-7.69A6.55,6.55,0,0,1,445.09,106.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.74 33.21 59.28 86.19 79.83 91.76 119.69 87.13 114.08 27.49 54.74 33.21",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.55,81.43l-6.26,4.76a22.73,22.73,0,0,0,8.17,4.54,32.74,32.74,0,0,0,12.37,1S70.34,90.12,65.55,81.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.28,47c0,.1-10.08,1.15-22.53,2.36s-22.57,2.11-22.58,2S74.25,50.18,86.71,49,109.27,46.87,109.28,47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.87,55.12c0,.1-10.08,1.16-22.53,2.37s-22.57,2.1-22.58,2,10.08-1.16,22.54-2.37S109.86,55,109.87,55.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82,62.31c0,.1-10.08,1.16-22.53,2.36s-22.56,2.11-22.57,2,10.07-1.15,22.53-2.36S110.81,62.21,110.82,62.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45,69.26c0,.09-10.08,1.15-22.54,2.36s-22.56,2.11-22.57,2,10.08-1.16,22.54-2.36S111.44,69.16,111.45,69.26Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.39,459.9c0,.14-105.4.26-235.38.26s-235.4-.12-235.4-.26,105.37-.27,235.4-.27S484.39,459.75,484.39,459.9Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Thesis--inject-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "41.94 125.35 84.1 366.77 261.88 338.86 270.12 318.95 222.02 95.72 55.38 105.66 41.94 125.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.1 366.77 96.73 347.42 54.57 105.99 41.94 125.35 84.1 366.77",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.57 105.99 96.73 347.42 270.12 318.95 226.31 81.5 54.57 105.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,106l171.71-24.7.21,0,0,.2C238.78,147.81,254,230,270.38,318.9l.05.27-.27.05-2.86.47-170.53,28-.24,0,0-.24C71.73,204.86,54.94,108.12,54.57,106c.37,2.13,17.36,98.83,42.4,241.38l-.28-.19,170.52-28,2.86-.47-.22.31c-16.38-88.91-31.52-171.1-43.75-237.46l.24.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.29,
    cy: 216.42,
    r: 29.55,
    transform: "translate(-71.88 350.78) rotate(-82.43)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.74,224.18l-1.34-8.51L178.87,211l1.26,8s-1.8,6.88-13.72,8.76S150.74,224.18,150.74,224.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.75 215.72 165.78 219.46 184.02 209.2 162.96 205.87 144.75 215.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.64,
    y: 141.39,
    width: 110.49,
    height: 6.96,
    rx: 2.35,
    transform: "translate(-20.75 25.48) rotate(-8.98)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.57,
    y: 155.76,
    width: 71.79,
    height: 6.96,
    rx: 2.35,
    transform: "translate(-22.96 26.05) rotate(-8.98)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 303.89,
    width: 71.79,
    height: 6.96,
    rx: 2.35,
    transform: "translate(-45.78 31.59) rotate(-8.98)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.19,325.66l-.84.16-2.48.43-9.59,1.6-35.61,5.84L92.37,353.24l-.26.05,0-.26c-1.68-9.55-3.45-19.55-5.25-29.74C77.18,268.54,68.46,219,62.15,183.11c-3.13-17.94-5.66-32.45-7.42-42.49-.86-5-1.53-8.91-2-11.56-.22-1.32-.39-2.32-.51-3s-.15-1-.15-1,.08.35.21,1,.31,1.69.55,3c.48,2.65,1.18,6.54,2.09,11.54,1.79,10,4.38,24.54,7.58,42.46,6.35,35.88,15.13,85.42,24.82,140.16,1.8,10.18,3.56,20.19,5.25,29.74l-.31-.22,120.34-19.38,35.63-5.68,9.6-1.51,2.49-.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,334.74l-.79.16-2.34.41-9.06,1.54-33.68,5.62L87.83,361.39l-.26,0,0-.25L81,325.47c-9.79-54-18.65-102.85-25.07-138.23-3.18-17.68-5.76-32-7.54-41.9-.87-4.94-1.56-8.78-2-11.4-.22-1.29-.4-2.28-.51-3s-.16-1-.16-1,.08.33.21,1l.57,3c.48,2.61,1.2,6.44,2.12,11.37l7.7,41.87c6.46,35.38,15.38,84.23,25.23,138.2,2.22,12.23,4.4,24.2,6.49,35.71l-.3-.21,114.31-18.74,33.7-5.47,9.07-1.45,2.35-.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.76 208.23 54.85 213.75 64.34 270.64 69.99 272.56 58.76 208.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.17,
    y: 205.38,
    width: 27.48,
    height: 65.3,
    transform: "translate(-39.79 16.95) rotate(-9.91)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 200.62,
    width: 5.49,
    height: 69.84,
    rx: 1.85,
    transform: "translate(-39.15 19.31) rotate(-9.9)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.08,254.77A12.42,12.42,0,0,1,41.82,244a12.4,12.4,0,0,1,20.79-10.69l16.9-9.6a2.32,2.32,0,0,1,3.43,1.62l4,22.89a2.31,2.31,0,0,1-2.65,2.69l-19.08-3a12.44,12.44,0,0,1-11.13,6.88Zm0-22.81a9.47,9.47,0,0,0-1.5.11,10.58,10.58,0,0,0-8.81,11.68,10.4,10.4,0,0,0,19.9,2.64l.3-.72L84.61,249a.28.28,0,0,0,.27-.09.31.31,0,0,0,.09-.27l-4-22.9a.32.32,0,0,0-.18-.23.32.32,0,0,0-.29,0L62.25,235.83l-.54-.57A10.43,10.43,0,0,0,54.11,232Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.68,267.75a3.53,3.53,0,0,1-.14-.64c-.09-.48-.2-1.09-.35-1.84-.3-1.67-.72-4-1.24-6.8-1-5.79-2.44-13.69-4-22.42s-2.89-16.65-3.89-22.46c-.47-2.82-.85-5.13-1.12-6.81-.12-.76-.21-1.38-.28-1.86a2.64,2.64,0,0,1-.06-.65,4.63,4.63,0,0,1,.16.63c.1.48.23,1.09.38,1.84.32,1.67.76,4,1.29,6.79,1.07,5.73,2.5,13.66,4,22.42s2.9,16.71,3.84,22.46c.48,2.88.84,5.21,1.08,6.82.11.81.21,1.43.25,1.87A2.66,2.66,0,0,1,94.68,267.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,272.78a5.68,5.68,0,0,1-.14-.65c-.09-.47-.2-1.08-.34-1.84-.31-1.67-.73-4-1.25-6.79-1-5.8-2.44-13.7-4-22.43s-2.88-16.65-3.89-22.45c-.47-2.83-.85-5.14-1.12-6.81-.12-.77-.21-1.38-.28-1.86a2.71,2.71,0,0,1-.06-.66,3.68,3.68,0,0,1,.17.64c.09.48.22,1.09.37,1.84.32,1.67.76,4,1.29,6.78,1.07,5.74,2.5,13.66,4,22.43s2.9,16.7,3.85,22.45c.47,2.88.84,5.21,1.07,6.83.11.81.21,1.43.25,1.86A2.74,2.74,0,0,1,69.45,272.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,209.2a10.26,10.26,0,0,1-1.38.89l-3.86,2.27c-3.28,1.9-7.83,4.49-12.87,7.33l-.09.05-.09,0-.21,0c-5.75-1-11-2-14.7-2.69l-4.45-.87a9.33,9.33,0,0,1-1.62-.4,12.11,12.11,0,0,1,1.66.19l4.47.71c3.78.62,9,1.52,14.74,2.54l.2,0-.18,0c5.05-2.83,9.63-5.37,13-7.19l3.95-2.12A8.63,8.63,0,0,1,184,209.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.99, -0.16, 0.16, 0.99, 121.26, 135.83)",
    style: {
      fontSize: "14.684189796447754px",
      fill: "#263238",
      fontFamily: "Montserrat-ExtraBold, Montserrat",
      fontWeight: 800
    }
  }, "THESIS")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.18,325.79h85.26a0,0,0,0,1,0,0v44.74a0,0,0,0,1,0,0H199.18a17.65,17.65,0,0,1-17.65-17.65v-9.45a17.65,17.65,0,0,1,17.65-17.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.15,325.79H442a2.93,2.93,0,0,1,2.93,2.93v1.57a2.93,2.93,0,0,1-2.93,2.93H262.15a0,0,0,0,1,0,0v-7.43A0,0,0,0,1,262.15,325.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.15,363.11H442a2.93,2.93,0,0,1,2.93,2.93v1.57a2.93,2.93,0,0,1-2.93,2.93H262.15a0,0,0,0,1,0,0v-7.43a0,0,0,0,1,0,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.46,363.11H282.55a14.94,14.94,0,0,1-14.94-14.95h0a14.94,14.94,0,0,1,14.94-14.94H439.46A37,37,0,0,0,439.46,363.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.61,370.54H199.53a18,18,0,0,1-18-18v-8.89a17.86,17.86,0,0,1,17.86-17.86h69.91C253.11,335.61,254.32,359.11,267.61,370.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.4,349.55c0,.15-32.21.27-71.93.27s-71.93-.12-71.93-.27,32.2-.27,71.93-.27S420.4,349.4,420.4,349.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.2,356.19c0,.15-32.21.27-71.93.27s-71.93-.12-71.93-.27,32.2-.26,71.93-.26S435.2,356.05,435.2,356.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.84,340.13c0,.15-32.21.27-71.93.27s-71.94-.12-71.94-.27,32.2-.27,71.94-.27S430.84,340,430.84,340.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.73,367.4c0,.15-15.08.27-33.67.27s-33.67-.12-33.67-.27,15.07-.27,33.67-.27S259.73,367.25,259.73,367.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.73,329.51c0,.15-15.08.27-33.67.27s-33.67-.12-33.67-.27,15.07-.27,33.67-.27S259.73,329.36,259.73,329.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.54,401.94H276.43a0,0,0,0,1,0,0v57.62a0,0,0,0,1,0,0H161.54a17.65,17.65,0,0,1-17.65-17.65V419.59a17.65,17.65,0,0,1,17.65-17.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.72,401.94H480.15a2.93,2.93,0,0,1,2.93,2.93v3.71a2.93,2.93,0,0,1-2.93,2.93H247.72a0,0,0,0,1,0,0v-9.57A0,0,0,0,1,247.72,401.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.72,450H480.15a2.93,2.93,0,0,1,2.93,2.93v3.71a2.93,2.93,0,0,1-2.93,2.93H247.72a0,0,0,0,1,0,0V450A0,0,0,0,1,247.72,450Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.06,450H274a19.25,19.25,0,0,1-19.24-19.25h0A19.24,19.24,0,0,1,274,411.51H476.06A47.59,47.59,0,0,0,476.06,450Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.74,459.56H161.31a17.41,17.41,0,0,1-17.41-17.42V420a18,18,0,0,1,18-18h95C236.07,414.58,237.63,444.85,254.74,459.56Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.51,432.54c0,.15-41.48.27-92.63.27s-92.64-.12-92.64-.27,41.47-.27,92.64-.27S451.51,432.39,451.51,432.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.58,441.09c0,.15-41.48.27-92.64.27s-92.64-.12-92.64-.27,41.47-.26,92.64-.26S470.58,441,470.58,441.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465,424.6c0,.15-41.47.27-92.63.27s-92.64-.12-92.64-.27,41.47-.27,92.64-.27S465,424.45,465,424.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.59,455.52c0,.15-19.41.27-43.36.27s-43.36-.12-43.36-.27,19.41-.26,43.36-.26S244.59,455.38,244.59,455.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.59,406.73c0,.14-19.41.26-43.36.26s-43.36-.12-43.36-.26,19.41-.27,43.36-.27S244.59,406.58,244.59,406.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.18,369.16h94.66a0,0,0,0,1,0,0v33a0,0,0,0,1,0,0H216.18a13,13,0,0,1-13-13v-7a13,13,0,0,1,13-13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.52,369.16H475.68a3.07,3.07,0,0,1,3.07,3.07v1.64a3.07,3.07,0,0,1-3.07,3.07H287.52a0,0,0,0,1,0,0v-7.77A0,0,0,0,1,287.52,369.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.52,394.38H475.68a3.07,3.07,0,0,1,3.07,3.07v1.64a3.07,3.07,0,0,1-3.07,3.07H287.52a0,0,0,0,1,0,0v-7.77A0,0,0,0,1,287.52,394.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,394.38H302a8.73,8.73,0,0,1-8.73-8.72h0a8.73,8.73,0,0,1,8.73-8.73H473Q466.44,385.66,473,394.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.22,402.15h-77a13.09,13.09,0,0,1-13.09-13.1v-6.52a13.36,13.36,0,0,1,13.36-13.37H295C278.05,376.4,279.32,393.73,293.22,402.15Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.09,384.28c0,.15-33.7.27-75.26.27s-75.26-.12-75.26-.27,33.69-.26,75.26-.26S453.09,384.14,453.09,384.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.58,389c0,.15-33.7.27-75.26.27s-75.26-.12-75.26-.27,33.69-.27,75.26-.27S468.58,388.83,468.58,389Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,398.87c0,.15-15.77.27-35.23.27s-35.23-.12-35.23-.27,15.77-.27,35.23-.27S285,398.72,285,398.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,373.05c0,.15-15.77.26-35.23.26s-35.23-.11-35.23-.26,15.77-.27,35.23-.27S285,372.9,285,373.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.5,369.16c0,.15-57.87.27-129.23.27S218,369.31,218,369.16s57.85-.27,129.24-.27S476.5,369,476.5,369.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.73 339.64 372.73 357.56 378.94 353.58 385.86 357.56 385.86 339.64 372.73 339.64",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "435.84 161.77 404.57 187.82 357.01 281.78 386.66 295.18 432.92 203.03 435.84 161.77",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.92,203a2.42,2.42,0,0,1-3-2.42,7.24,7.24,0,0,1-12.72-5.13,8.44,8.44,0,0,1-12.43-7.86l31-25.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.26,172.25s.48,7.78,11.38,6.42l1.2-16.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.24,195.48l-45.85,92.29-14.38-6,47.56-94,.24-.2a8.15,8.15,0,0,0,.64,3.66,8.87,8.87,0,0,0,3.08,3.76,8.32,8.32,0,0,0,5.69,1.39A8.69,8.69,0,0,0,417.24,195.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,200.61l-47.1,92.85,3.8,1.72L432.92,203a2.57,2.57,0,0,1-2.93-1.82A2.91,2.91,0,0,1,430,200.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,186.52a.67.67,0,0,0-.16.41.88.88,0,0,0,.8.87,3.33,3.33,0,0,0,2-.56,2.11,2.11,0,0,0,.85-.94,1.39,1.39,0,0,0-.09-1.34,1.86,1.86,0,0,0-1.36-.69,6,6,0,0,0-1.73.1,9.35,9.35,0,0,0-3.57,1.39,2.38,2.38,0,0,0-1.1,1.63,2.13,2.13,0,0,0,.87,1.81,5.68,5.68,0,0,0,4.38.54A8.06,8.06,0,0,0,424,184a2.09,2.09,0,0,0-.46-1.8,3.81,3.81,0,0,0-1.54-1,11,11,0,0,0-3.29-.66,12.21,12.21,0,0,0-4.82.72c-.54.2-1,.39-1.23.52s-.42.2-.42.2a8.93,8.93,0,0,1,1.62-.81,12.13,12.13,0,0,1,4.85-.79,11.11,11.11,0,0,1,3.36.64,4,4,0,0,1,1.62,1.05,2.32,2.32,0,0,1,.52,2,8.35,8.35,0,0,1-8.64,6.09,4.16,4.16,0,0,1-2.19-.76,2.32,2.32,0,0,1-1-2,2.6,2.6,0,0,1,1.2-1.78,9.52,9.52,0,0,1,3.66-1.41,6.37,6.37,0,0,1,1.79-.08,2,2,0,0,1,1.46.77,1.56,1.56,0,0,1,.09,1.49,2.25,2.25,0,0,1-.91,1,3.37,3.37,0,0,1-2.05.53.93.93,0,0,1-.84-.95C416.83,186.6,417,186.51,417,186.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.78,186s-.46-.07-1.28,0a8.92,8.92,0,0,0-3.36.9,22.78,22.78,0,0,0-4.32,2.88,19.41,19.41,0,0,1-5.44,3.38,11,11,0,0,1-6.36.24,10.72,10.72,0,0,1-4.57-2.52A10.59,10.59,0,0,1,406.3,188a7.26,7.26,0,0,1-.52-1.18,2.23,2.23,0,0,1,.15.29c.09.2.24.49.44.85a11.31,11.31,0,0,0,2.19,2.71,10.68,10.68,0,0,0,4.51,2.44,11,11,0,0,0,6.24-.26,19.49,19.49,0,0,0,5.38-3.32,21.65,21.65,0,0,1,4.38-2.86,8.52,8.52,0,0,1,3.42-.85A5.12,5.12,0,0,1,433.78,186Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.6,195.37a3.39,3.39,0,0,0-2.15-1,19.05,19.05,0,0,0-5.83.86,32.43,32.43,0,0,0-5.56,2.06c-.69.33-1.23.62-1.61.81a3.44,3.44,0,0,1-.59.3,4.67,4.67,0,0,1,.55-.37c.36-.22.9-.54,1.58-.88a28.31,28.31,0,0,1,5.57-2.14,27.83,27.83,0,0,1,3.22-.68,9.65,9.65,0,0,1,2.69-.11,3.3,3.3,0,0,1,1.68.68A2.26,2.26,0,0,1,433.6,195.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.62,202a6.51,6.51,0,0,1,1-.85,7.54,7.54,0,0,1,3-1.32,3.73,3.73,0,0,1,3.11.77,2.76,2.76,0,0,1,.63.77,1,1,0,0,1,.12.34,4.35,4.35,0,0,0-.85-1,3.72,3.72,0,0,0-3-.67,8.14,8.14,0,0,0-2.91,1.24A11.3,11.3,0,0,1,420.62,202Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.6,180.35a.83.83,0,0,1-.15.13c-.1.07-.25.18-.46.31a2.26,2.26,0,0,1-.81.36,2.54,2.54,0,0,1-1.18-.07c-.85-.19-1.8-.62-2.87-1a22.3,22.3,0,0,0-3.56-.89,43.61,43.61,0,0,0-6.69-.45h-2a3.71,3.71,0,0,1-.75,0l.75-.06,2-.07a37.66,37.66,0,0,1,6.72.39,19.91,19.91,0,0,1,3.6.92c1.08.38,2,.82,2.84,1a2.18,2.18,0,0,0,1.91-.21A7.48,7.48,0,0,1,434.6,180.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graduation-cap--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.74,265.27v81.91a.65.65,0,0,0,1.29,0V265.27a.65.65,0,0,0-1.29,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,329.13a4.62,4.62,0,1,1-4.62-4.62A4.62,4.62,0,0,1,473,329.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.1,331.52s-3.37,3.37-4.38,13.24-1.23,14.8-1.23,14.8l9.08.56v-7.06c0,.33,1.8,5.27,1.8,5.27l7.18-2.36S477,329.73,467.1,331.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.67,
    y: 271.97,
    width: 154.2,
    height: 55.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.28,
    y: 262.41,
    width: 263.75,
    height: 9.57,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,311.79s46.84-16.8,77.1-23,77.1-4.14,77.1-4.14V272H265.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.28,
    y: 262.41,
    width: 95.4,
    height: 9.57,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.12,272c0,.15-58.65.27-131,.27s-131-.12-131-.27,58.63-.26,131-.26S472.12,271.83,472.12,272Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.53,272.05a43.88,43.88,0,0,1,0-9.72,45.55,45.55,0,0,1,0,9.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.52,327.57c-.14,0-.26-10.85-.26-24.23s.12-24.22.26-24.22.27,10.84.27,24.22S327.67,327.57,327.52,327.57Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.45,395.84l17.73-7.16,13.54-35.37,18.05,9.3s-1.74,3.49-5.47,12.14c-1.45,3.33-6.22,12.64-8.16,17.17a23.86,23.86,0,0,1-21.27,14.45l-16.64.43Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.64,389,93,386.18a3,3,0,0,0-1.73-.49l-8.48.26a5.3,5.3,0,0,0-3.93,2.38l-3.09,5.25s-2.07,3.59-1.81,4.47a1.55,1.55,0,0,0,1.79,1.05s.3,1.66.85,2a2.64,2.64,0,0,0,2.07.13,1.73,1.73,0,0,0,1.67,1,2.57,2.57,0,0,0,.44-.08c1-.31,1.46-2.26,1.46-2.26l4.3-.79s6.18,4.13,8.36,6.83,7.88.64,7.88.64l2.13-10.2Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,390.21a7,7,0,0,1-1.86.31c-1.17.13-2.82.18-4.69.42l.2-.15a17,17,0,0,1-1.1,2,22.82,22.82,0,0,1-4.08,4.83,7.83,7.83,0,0,1-2.13,1.52c0-.07.75-.67,1.87-1.8a28.14,28.14,0,0,0,3.89-4.83c.41-.67.78-1.33,1.09-2l.06-.13.14,0c1.91-.21,3.56-.19,4.73-.23A9.08,9.08,0,0,1,89.39,390.21Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.58,394.26a4.22,4.22,0,0,1-1.6.42,12.19,12.19,0,0,1-4.15-.14l.31-.17a16,16,0,0,1-.62,1.54,13.29,13.29,0,0,1-3.19,4.19,5.42,5.42,0,0,1-1.82,1.19,20.12,20.12,0,0,1,1.56-1.47,14.85,14.85,0,0,0,3-4.15,13.89,13.89,0,0,0,.61-1.47l.08-.22.22,0A20.84,20.84,0,0,0,89.58,394.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.36,396.35l-7.57-3.52a8.13,8.13,0,0,0-3.3-1A7.87,7.87,0,0,0,86,393l-4.08,2.1c-.22.12-.46.26-.53.49s.12.63.35.86a6,6,0,0,0,7.88.32,16.19,16.19,0,0,0,2.55,5,5.54,5.54,0,0,0,5,2.13",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.15,404a.63.63,0,0,1-.2.06,2.75,2.75,0,0,1-.62.08,4.85,4.85,0,0,1-2.28-.56,7.14,7.14,0,0,1-2.68-2.44,19.91,19.91,0,0,1-2-4.22l.38.09a6,6,0,0,1-4.41,1.38,6.27,6.27,0,0,1-2.46-.69,5.71,5.71,0,0,1-1.09-.75,3.33,3.33,0,0,1-.49-.5,1,1,0,0,1-.21-.83.9.9,0,0,1,.45-.56c.18-.11.33-.18.49-.27l.94-.48,1.85-1a16.77,16.77,0,0,1,3.65-1.59,5.6,5.6,0,0,1,3.59.55c1,.46,2,.92,2.8,1.33l4,2a10.92,10.92,0,0,1,1.45.79,9.92,9.92,0,0,1-1.54-.6l-4.1-1.81-2.82-1.26a5.11,5.11,0,0,0-3.3-.47,16.58,16.58,0,0,0-3.52,1.57l-1.84,1-.94.49c-.32.16-.66.32-.68.48s.23.55.54.8a5.12,5.12,0,0,0,1,.68,5.86,5.86,0,0,0,2.25.64,5.59,5.59,0,0,0,4.06-1.22l.26-.22.11.32a20.52,20.52,0,0,0,1.87,4.17,7,7,0,0,0,2.48,2.41A5.48,5.48,0,0,0,97.15,404Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,297.27c.07-5.68,1-11.34.74-17s-1.71-11.59-5.67-15.66S183,259,178.4,262.25l-1,4.84c1.82,21.9,1.58,44.15,3.4,66.05.24,2.88,2.57,5.49,3.88,8.06s3.94,4.7,6.82,4.52c3.77-.23,6.24-4.05,7.41-7.65C203.21,325.06,198.63,311,198.8,297.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.14,267.82a16,16,0,0,0-2.89-3.91,5.41,5.41,0,0,0-4.47-1.5,2.25,2.25,0,0,0-1.77,1.3c-.25.72.29,1.69,1.05,1.62l.16.14q2.55,2.26,5.19,4.41a4.4,4.4,0,0,0,1.45.9,1.53,1.53,0,0,0,1.59-.34C186.08,269.74,185.62,268.63,185.14,267.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,273.4c-5.66-6.92-13.26-10.91-22.2-11-5-.09-7.13,1-10.76,1.94a16,16,0,0,0-9.08,6c-2.57,3.65-4.73,7.74-5.22,12.19a74.25,74.25,0,0,0-.65,13.73,25,25,0,0,0,4.28,12.89l11.64,2c6.43.22,12.95.43,19.22-1s12.35-4.84,15.7-10.33C195.94,292.14,194,280.31,188.35,273.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,273.32l-15.52-6.17-4.06.47c-9.12,0-15.42,10.1-15.48,17.48-.06,8.22.18,18.24,1.48,24.29,2.63,12.17,13,13.18,13,13.18s-.21,6.49-.29,10.57l23.77-1.71,1.19-53.94A4.32,4.32,0,0,0,178,273.32Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,306.54a2.58,2.58,0,0,0-.9-1.59,2.65,2.65,0,0,0-3.21-.19,3.56,3.56,0,0,0-1.35,3.33h0a3.23,3.23,0,0,0,2.31,1.34,3.09,3.09,0,0,0,.43,0,2.83,2.83,0,0,0,2-.77A2.58,2.58,0,0,0,162.67,306.54Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,295.49a1.57,1.57,0,0,0,1.6,1.51,1.52,1.52,0,0,0,1.55-1.51,1.59,1.59,0,0,0-1.61-1.51A1.51,1.51,0,0,0,147.05,295.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.72,289.21c.2.19,1.35-.75,3-.84s3,.69,3.16.47-.14-.46-.7-.82a4.32,4.32,0,0,0-2.54-.63,4.16,4.16,0,0,0-2.41.92C145.77,288.74,145.61,289.12,145.72,289.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6,302.5a10.67,10.67,0,0,0-2.78-.35c-.43,0-.85-.08-.94-.38a2.28,2.28,0,0,1,.22-1.29c.35-1.07.72-2.19,1.1-3.37,1.52-4.78,2.6-8.71,2.4-8.77s-1.58,3.77-3.1,8.56l-1,3.38a2.47,2.47,0,0,0-.13,1.71,1.06,1.06,0,0,0,.74.59,2.86,2.86,0,0,0,.74.06A11.7,11.7,0,0,0,156.6,302.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,322.56a31.26,31.26,0,0,0,16.2-5.29s-3.91,8.75-16.26,8.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.65,303.39c-.27,0-.18,1.84-1.68,3.23s-3.47,1.3-3.47,1.56.46.33,1.28.31a4.57,4.57,0,0,0,2.91-1.2,4,4,0,0,0,1.29-2.7C162,303.82,161.78,303.38,161.65,303.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29,283.28c.31.39,1.59.05,3.11.09s2.8.37,3.12,0c.14-.19-.05-.58-.6-1a4.52,4.52,0,0,0-2.5-.73,4.61,4.61,0,0,0-2.52.67C146.35,282.69,146.16,283.08,146.29,283.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.54,295.07a1.58,1.58,0,0,1-1.5,1.61,1.51,1.51,0,0,1-1.65-1.39,1.59,1.59,0,0,1,1.49-1.62A1.52,1.52,0,0,1,165.54,295.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,288.55c-.19.21-1.4-.65-3.1-.62s-2.92.91-3.11.7.1-.46.64-.87a4.29,4.29,0,0,1,2.48-.81,4.14,4.14,0,0,1,2.47.75C168.55,288.09,168.74,288.46,168.64,288.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,283.13c-.32.39-1.64,0-3.21,0s-2.91.31-3.22-.09c-.14-.19.07-.58.64-1a4.9,4.9,0,0,1,2.61-.67,4.7,4.7,0,0,1,2.57.73C167.58,282.54,167.77,282.94,167.62,283.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,298.11c0-.91.89-3.12,1.79-3.31,2.39-.51,6.74-.56,7.12,5.56.52,8.37-8,7.16-8,6.92S180.15,301.27,180,298.11Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,304.08s.15.1.4.19a1.46,1.46,0,0,0,1.1,0c.86-.38,1.52-1.83,1.47-3.34a4.83,4.83,0,0,0-.54-2.06,1.67,1.67,0,0,0-1.17-1.05.74.74,0,0,0-.83.45c-.1.24,0,.41-.08.42s-.19-.13-.14-.48a.9.9,0,0,1,.3-.54,1.05,1.05,0,0,1,.79-.26,2,2,0,0,1,1.6,1.2,5,5,0,0,1,.65,2.3c.05,1.69-.72,3.32-1.9,3.74a1.58,1.58,0,0,1-1.35-.13C183,304.29,183,304.1,183,304.08Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.11,294.82,180,297c-9.18-8.79-27.12-30.79-26.11-29.48A26.62,26.62,0,0,1,167,266.13c6.83,1.16,19.77,4.58,19.57,12.63S182.11,294.82,182.11,294.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,293a2.48,2.48,0,0,0-.13-.48,8.5,8.5,0,0,0-.57-1.32,12.19,12.19,0,0,0-3.5-3.93,22.74,22.74,0,0,0-7-3.39c-2.8-.91-5.95-1.62-9.05-3a40.86,40.86,0,0,1-8.26-4.63,42.63,42.63,0,0,1-5.84-5.1,45.41,45.41,0,0,1-3.37-4l-.84-1.16a2.58,2.58,0,0,0-.32-.39,2.85,2.85,0,0,0,.25.44c.17.28.42.69.77,1.2a38.45,38.45,0,0,0,3.29,4.12,40.32,40.32,0,0,0,14.16,9.92,94.67,94.67,0,0,0,9.09,2.93,23,23,0,0,1,7,3.25,12.64,12.64,0,0,1,3.53,3.77C194,292.32,194.22,293,194.27,293Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.83,294.29a4.32,4.32,0,0,0-.32-1.83,8.58,8.58,0,0,0-3.15-3.94,18.87,18.87,0,0,0-7-2.73,41.29,41.29,0,0,1-8.67-2.76,36.68,36.68,0,0,1-7.74-4.77,38.67,38.67,0,0,1-5.3-5.21,39.14,39.14,0,0,1-3-4.07l-.71-1.17a1.9,1.9,0,0,0-.27-.39,3.14,3.14,0,0,0,.2.43l.64,1.22a34.86,34.86,0,0,0,2.86,4.17,36.66,36.66,0,0,0,5.29,5.33,36.12,36.12,0,0,0,7.81,4.85,39.83,39.83,0,0,0,8.76,2.75,19,19,0,0,1,6.9,2.6,8.62,8.62,0,0,1,3.16,3.75A10.07,10.07,0,0,1,191.83,294.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.83,309c0-.06.71-.15,1.95-.48a11.87,11.87,0,0,0,4.68-2.61,16.74,16.74,0,0,0,4.35-6.66,29.47,29.47,0,0,0,1.82-9.65,24.84,24.84,0,0,0-.41-5.08,23.48,23.48,0,0,0-5.72-11.28,37.55,37.55,0,0,0-5.62-4.89s.17.06.47.24.73.42,1.26.8a25.48,25.48,0,0,1,4.18,3.59,23.7,23.7,0,0,1,4.51,6.81,24.31,24.31,0,0,1,1.45,4.63,25.27,25.27,0,0,1,.43,5.19,29.17,29.17,0,0,1-1.89,9.82,16.89,16.89,0,0,1-4.57,6.77,11.68,11.68,0,0,1-4.88,2.53,11.89,11.89,0,0,1-1.49.24A3.34,3.34,0,0,1,181.83,309Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.48,411.91,143,419.1c-18.59,5.26-38.17,6.8-58.64,5l74.47,34.74,29.9.46s9.1,0,10.69-7.94,3.36-32.12,3.36-32.12S196.87,414.12,192.48,411.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.33,432.74a71.66,71.66,0,0,1,.88,15,14.85,14.85,0,0,0,3.66-12.5c-.43-2.44-1.45-5.13-.17-7.26.86-1.43,3.13-3.07,2.8-4.7,0,0-2,0-3.79-.07-1.45-.06-4.46-.15-4.46-.15a16,16,0,0,1,.8,9.83"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "157.21 331.1 181.25 328.5 185.65 332.5 168.49 342.6 160.92 346.52 153.44 344.25 151.07 339.79 157.21 331.1",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,360.37s7.54-14.46,9.4-17.62c3.18-5.39,9.12-8.44,9.12-8.44l13.89-3.21s-1.44,7,7.2,7.44c11,.61,17.83-9.93,17.83-9.93s12.54,1.29,16,2.74,13.26,5.56,14.7,18.58l3.36,21.27-26.5,2,.36,28.32-11.26,9.21s-32.33,11.13-34.4,11.86c-1,.35-.74-13.39-3.05-25.17l-4.36-10.59A41.07,41.07,0,0,1,134,373.53c-.17-3-.09-5.3-.09-5.3S127.11,365.9,124.8,360.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.68,411.49l44.43-13.33-.31-24.94,22.62-1.72s-1.8,12.92-2.07,19.54c-.38,9.53-5,22.85-8,25.67s-57.82,5.9-57.82,5.9Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,419.33a1.75,1.75,0,0,0,2.19.73c1-.4.73-2.42.73-2.42l4.73-1.16s6.53,3.54,9,6,7.9-.11,7.9-.11L146.16,412l-9.43-7.29s.58.44-.15-1-3.45-.66-3.45-.66c-.48-.71-2.31-.83-2.31-.83l-7.67,1.49a5.31,5.31,0,0,0-3.68,2.73l-2.87,5.43s-1.44,3.86-1.09,4.71a1.56,1.56,0,0,0,1.88.88s.57,2.42,1.22,2.45a5.15,5.15,0,0,0,1.87-.61Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.37,410.73c0,.08-1,.06-2.68.26a23.83,23.83,0,0,0-6.22,1.67,22.62,22.62,0,0,0-3.15,1.65c-.89.59-1.83,1.1-2.08,1.81a.94.94,0,0,0,.16.91,1.33,1.33,0,0,0,.62.45c.42.13.67,0,.69,0s-.23.23-.74.14a1.47,1.47,0,0,1-.78-.46,1.24,1.24,0,0,1-.28-1.2,2.48,2.48,0,0,1,.88-1.16c.4-.31.82-.62,1.29-.93a20.39,20.39,0,0,1,9.57-3.27A8.46,8.46,0,0,1,136.37,410.73Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3,415.62c0,.14-3.16.26-7,.78s-6.92,1.24-7,1.1a7.86,7.86,0,0,1,2-.65,43.53,43.53,0,0,1,4.92-.94,44,44,0,0,1,5-.39A7.64,7.64,0,0,1,137.3,415.62Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.51,419.13a4,4,0,0,1-.16-.81,20,20,0,0,1-.18-2.27,9.93,9.93,0,0,1,.1-1.58,4.7,4.7,0,0,1,.63-1.74,10.54,10.54,0,0,1,2.66-3.2,14.69,14.69,0,0,1,3.56-2.15,13.46,13.46,0,0,1,3.3-.77c1-.11,1.72-.14,2.26-.17a2.85,2.85,0,0,1,.83,0,25.51,25.51,0,0,1-3,.5,14.64,14.64,0,0,0-3.18.84,14.94,14.94,0,0,0-3.42,2.12,10.86,10.86,0,0,0-2.58,3,6,6,0,0,0-.77,3.11C120.48,417.94,120.62,419.13,120.51,419.13Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,404.24c0,.08-1.15.2-3,.55s-4.6.76-6,3.34a26.52,26.52,0,0,0-3.43,6.37,15.63,15.63,0,0,0-.51,2.95,2,2,0,0,1-.11-.82,7.57,7.57,0,0,1,.28-2.23,23,23,0,0,1,3.36-6.55,8.1,8.1,0,0,1,1.39-1.63,5.34,5.34,0,0,1,1.75-1,16.61,16.61,0,0,1,3.24-.77A12.16,12.16,0,0,1,130.6,404.24Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.27,421a3.08,3.08,0,0,1-.49-.32l-1.37-.93a54.63,54.63,0,0,0-5.36-3.11h.11l-4.72,1.19.15-.22a5.17,5.17,0,0,1,0,1.18,2.2,2.2,0,0,1-.45,1.19,1.17,1.17,0,0,1-.61.34,1.68,1.68,0,0,1-.67.09,2,2,0,0,1-1.25-.56,3,3,0,0,1-.23-.27l0-.07,0,0v0h0l.28.08h0l-.15.07a5.46,5.46,0,0,1-.6.27,6,6,0,0,1-.64.21,2,2,0,0,1-.35.07.84.84,0,0,1-.45-.05,1.38,1.38,0,0,1-.52-.6,5.24,5.24,0,0,1-.29-.64,9.77,9.77,0,0,1-.41-1.33l.29.17a1.81,1.81,0,0,1-1.83-.47,1.47,1.47,0,0,1-.4-.94,4.83,4.83,0,0,1,.09-.94,25.58,25.58,0,0,1,1.06-3.54v0h0l1.53-2.9,1-1.83a10,10,0,0,1,1.08-1.79,5.28,5.28,0,0,1,1.65-1.29,6.77,6.77,0,0,1,1.94-.56l7.22-1.39h.06a6.31,6.31,0,0,1,1.31.24,2.19,2.19,0,0,1,1.17.69l-.28-.06a2.7,2.7,0,0,1,2.5-.06,3.21,3.21,0,0,1,1.38,1.86l-.07-.09,6.5,5,1.75,1.38a4.58,4.58,0,0,1,.59.51,4,4,0,0,1-.65-.42l-1.81-1.31-6.6-4.86-.05,0,0-.07a2.76,2.76,0,0,0-1.21-1.61,2.27,2.27,0,0,0-2.1.07l-.17.08-.11-.14a1.83,1.83,0,0,0-.94-.52,6.23,6.23,0,0,0-1.22-.21h.06l-7.22,1.42a6.17,6.17,0,0,0-1.82.53,4.62,4.62,0,0,0-1.48,1.16,9.21,9.21,0,0,0-1,1.71l-1,1.83c-.53,1-1,2-1.53,2.9v0a26.14,26.14,0,0,0-1,3.46,4.2,4.2,0,0,0-.09.83,1,1,0,0,0,.28.64,1.35,1.35,0,0,0,1.34.34l.24-.06,0,.23c.11.43.24.87.39,1.28a2.42,2.42,0,0,0,.58,1,.35.35,0,0,0,.2,0l.29-.06a3.37,3.37,0,0,0,.59-.19c.19-.07.38-.16.57-.25l.14-.06h0l.29.08h0v0l0,0,0,.05a1.92,1.92,0,0,0,.18.22,1.43,1.43,0,0,0,1.49.38.77.77,0,0,0,.42-.22,3,3,0,0,0,.37-2v-.18l.16,0,4.74-1.12h.06l0,0a45,45,0,0,1,5.31,3.25c.59.43,1,.77,1.33,1A3.57,3.57,0,0,1,135.27,421Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.17,427.42s-31.35-9.85-41.19-13c-17-5.5-28.06.06-31.56,6.12-4.54,7.87,6.35,23.22,10.55,26.75,12.43,10.45,33.74,11.86,33.74,11.86h0l76.62-.14L138,428.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87,441.64a76.36,76.36,0,0,1-37.61-5.12A49,49,0,0,0,73,434.19a18.52,18.52,0,0,0-6.47-.46,6.42,6.42,0,0,0-4.56,2.07c-1.53,2-.75,4.88.1,7.26,1,2.8,2,5.66,4,7.9,2.27,2.61,5.57,4.11,8.88,5.15,6.47,2,13.3,2.63,20.08,2.89l23.28-1.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.91,434.2a2.05,2.05,0,0,1,.35.63,9.48,9.48,0,0,1,.62,1.86,12,12,0,0,1-3.8,11.81,10.84,10.84,0,0,1-1.58,1.15c-.41.23-.64.33-.66.3s.84-.58,2-1.71a12.65,12.65,0,0,0,3.69-11.48C72.25,435.16,71.83,434.23,71.91,434.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,425.5c-1.82-5.16-2.12-12.74-13.35-16.38s-19.71,3.34-25.48,5.76-37.3,19.72-37.3,19.72-5.94,10.59-4.25,15.27,9.37,9.3,9.37,9.3h35.27c9.1,0,26-.31,26-.31a103.68,103.68,0,0,0,6.07-11.52l.3-1.52C188.85,444.61,194,430.66,192.19,425.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,452.29a1.12,1.12,0,0,1-.26.48,6.36,6.36,0,0,1-1.16,1.05,30.29,30.29,0,0,1-5,2.79,32.48,32.48,0,0,1-3.68,1.45,27.24,27.24,0,0,1-4.45,1,85.57,85.57,0,0,1-10.36.4c-7.33.12-14,.4-18.8.34-2.41,0-4.36-.11-5.7-.25a14.3,14.3,0,0,1-1.54-.22,2.64,2.64,0,0,1-.53-.12c0-.05.74.08,2.08.15s3.29.12,5.69.1c4.81,0,11.45-.37,18.8-.49a91.31,91.31,0,0,0,10.31-.36,27.77,27.77,0,0,0,4.38-.9,32,32,0,0,0,3.66-1.38,32.87,32.87,0,0,0,5-2.63,7.13,7.13,0,0,0,1.19-1C172.56,452.46,172.62,452.28,172.65,452.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,459.17l-.47-.25c-.3-.17-.74-.45-1.31-.82a31.72,31.72,0,0,1-4.64-3.69,14.6,14.6,0,0,1-2.62-3.38,7.83,7.83,0,0,1-.52-5,42.34,42.34,0,0,1,4.27-11.5l0-.05,0,0c5.78-3.18,12.41-6.79,19.65-10.68,3.62-1.94,7.39-3.95,11.31-6,2-1,4-2,6-3s4.05-2,6.12-3.08a34.6,34.6,0,0,1,9.11-3.43,22.4,22.4,0,0,1,4.75-.43,20.93,20.93,0,0,1,4.62.66,22.08,22.08,0,0,1,8.08,3.86,16.36,16.36,0,0,1,2.94,3.18,18.69,18.69,0,0,1,1.89,3.73c.5,1.28.85,2.57,1.21,3.83a30.37,30.37,0,0,1,1,3.74,24.55,24.55,0,0,1-.6,7.21c-.45,2.25-1,4.35-1.57,6.3-.28,1-.56,1.93-.82,2.84s-.56,1.81-.7,2.61v0c-.12.57-.21,1-.31,1.51h0a37.28,37.28,0,0,1-4.05,8.78,15.12,15.12,0,0,1-2.15,2.7l.13-.18c.11-.13.25-.29.42-.51a23.94,23.94,0,0,0,1.48-2.08,38.48,38.48,0,0,0,3.91-8.79h0c.57-.48.46-.95.29-1.52v0a24.24,24.24,0,0,1,.68-2.7l.81-2.83c.54-2,1.08-4.06,1.52-6.29a24.35,24.35,0,0,0,.56-7.09,33.24,33.24,0,0,0-1-3.67c-.37-1.26-.73-2.54-1.22-3.79a18.08,18.08,0,0,0-1.85-3.64,15.66,15.66,0,0,0-2.86-3.07,22.1,22.1,0,0,0-12.42-4.4,21.44,21.44,0,0,0-4.64.43,34,34,0,0,0-9,3.39c-2,1-4,2.2-6.15,3.09s-4,1.95-6,3c-3.91,2-7.69,4-11.31,6l-19.68,10.61.07-.08a42.42,42.42,0,0,0-4.29,11.37,7.49,7.49,0,0,0,.45,4.85,14,14,0,0,0,2.54,3.35,33.18,33.18,0,0,0,4.55,3.75l1.28.86C121,459.06,121.18,459.17,121.18,459.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.58,446.08s10.51,1.26,9.58,6.4-4.37,6.87-4.37,6.87l-28.56.06S172.28,458.23,178.58,446.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.6,443.59a3.52,3.52,0,0,1-.32,1.45,11,11,0,0,1-1.7,3.19,8.62,8.62,0,0,1-4,3.08,23.42,23.42,0,0,0,3.63-3.38A29.53,29.53,0,0,0,179.6,443.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,445.6a6.87,6.87,0,0,1-1,3.66,8,8,0,0,1-2.29,3c-.11-.09.92-1.42,1.85-3.25S175.82,445.58,176,445.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,457.92c-.08,0,.6-1.34,1.42-3.55a37.82,37.82,0,0,0,2.07-18.09c-.31-2.33-.67-3.76-.59-3.78a3.89,3.89,0,0,1,.34,1,25.52,25.52,0,0,1,.59,2.75,33.91,33.91,0,0,1-2.08,18.26A24.71,24.71,0,0,1,189.9,457,4.5,4.5,0,0,1,189.36,457.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.42,443.31c-.08-.69-.35-1.51-1-1.65-.84-.17-1.41.79-1.74,1.57C177,451.6,165.11,458.13,156,459a83.33,83.33,0,0,0,13.19-1.08,20,20,0,0,0,10.06-4.6A12.21,12.21,0,0,0,183.42,443.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M113.84,431.92a29.92,29.92,0,0,1-5.06-1.93,29.57,29.57,0,0,1-4.86-2.37,31.1,31.1,0,0,1,5.06,1.92A29.54,29.54,0,0,1,113.84,431.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124,427.5q-20.4-3.9-40.95-6.93l-10.2,3.22c2.86,5.32,8.51,8.71,14.38,10.11s12,1.07,18,.52c6.62-.61,13.42-1.54,19.18-4.86.44-.25.94-.63.88-1.14S124.59,427.61,124,427.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,387l17.14,37.9a4.42,4.42,0,0,0,4,2.61l50,.65,6.3-3.39-9.87-.72-15.36-36.86a3.17,3.17,0,0,0-2.9-1.95l-47.89-.36A1.5,1.5,0,0,0,57.06,387Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,387a1.16,1.16,0,0,1-.15-.46,1.52,1.52,0,0,1,.47-1.31,1.58,1.58,0,0,1,1-.42h4.39l20.05.07,13.94.07,7.79.05,2,0a3.39,3.39,0,0,1,2,.84,4.24,4.24,0,0,1,1.15,1.84l.82,2c4.37,10.47,9.2,22.05,14.32,34.29l-.24-.17,9.53.7.34,0,1,.07-.85.46-6.3,3.39-.07,0h-.07l-37.9-.52-8.46-.12c-1.38,0-2.7,0-4.07-.08a4.71,4.71,0,0,1-3.39-2.1c-2.23-4.69-4.09-9-5.9-13l-8.38-18.74c-1-2.19-1.72-3.9-2.24-5.09-.25-.56-.43-1-.57-1.32s-.18-.46-.18-.46a4.14,4.14,0,0,1,.23.44l.62,1.3c.54,1.17,1.32,2.87,2.33,5l8.54,18.68c1.81,3.93,3.75,8.35,5.93,12.91a4.2,4.2,0,0,0,3.06,1.88c1.28.06,2.67.05,4,.07l8.46.1,37.9.46-.14,0,6.3-3.4.12.53-.34,0-9.53-.69-.17,0-.07-.15c-5.09-12.26-9.91-23.84-14.27-34.32l-.81-1.95a3.7,3.7,0,0,0-1-1.67,2.86,2.86,0,0,0-1.72-.73l-2,0-7.79-.07-13.93-.14L62.74,385,59.6,385H58.36a1.46,1.46,0,0,0-1.4,1.59A3.81,3.81,0,0,0,57.06,387Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.12,428.09a2,2,0,0,1-.23-.42l-.57-1.22c-.5-1.14-1.18-2.68-2-4.54-1.67-3.85-3.94-9.17-6.38-15.09s-4.6-11.29-6.09-15.2c-.75-2-1.34-3.55-1.72-4.66-.18-.51-.32-.93-.44-1.28a2.27,2.27,0,0,1-.12-.46,1.8,1.8,0,0,1,.22.42l.52,1.25c.47,1.16,1.1,2.71,1.86,4.6,1.62,3.94,3.81,9.26,6.22,15.15s4.63,11.19,6.25,15.13l1.87,4.6c.19.51.35.92.48,1.26A1.4,1.4,0,0,1,123.12,428.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.12,405.37a2.46,2.46,0,1,1-2.45-2.45A2.45,2.45,0,0,1,92.12,405.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,344.4c.08,0-.64,1.39-1.65,3.63A62.47,62.47,0,0,0,134,366.47c-.3,2.45-.38,4-.47,4a3.65,3.65,0,0,1,0-1.08c0-.69,0-1.69.14-2.93a52.43,52.43,0,0,1,5.18-18.56c.55-1.11,1-2,1.39-2.58A4.4,4.4,0,0,1,140.77,344.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3,371.2a2.08,2.08,0,0,1-.55.09l-1.59.15-5.94.5-20.31,1.53-.26,0,0-.26c-.17-2.7-.35-5.55-.53-8.47-.29-5.1-.54-10-.62-14.39A20.38,20.38,0,0,1,189.09,339a14.11,14.11,0,0,1,5.69-5.47,12.17,12.17,0,0,1,2-.79,6.13,6.13,0,0,1,.73-.18c0,.08-1,.29-2.65,1.15a14.28,14.28,0,0,0-5.47,5.48A20.23,20.23,0,0,0,187,350.36c.1,4.41.36,9.27.65,14.37.18,2.92.35,5.77.52,8.46l-.28-.24,20.33-1.34,6-.35,1.59-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.47,388.52a3,3,0,0,1-.88-.32,8.42,8.42,0,0,1-1-.5,12.58,12.58,0,0,1-1.25-.77,17.66,17.66,0,0,1-2.93-2.48,21.44,21.44,0,0,1-2.8-3.78,21,21,0,0,1-1.81-4.34,17.87,17.87,0,0,1-.64-3.78,12.29,12.29,0,0,1,0-1.47,8.2,8.2,0,0,1,.08-1.11,2.93,2.93,0,0,1,.18-.93c.1,0-.07,1.35.14,3.48a19.59,19.59,0,0,0,.73,3.67,22.81,22.81,0,0,0,1.81,4.22,22,22,0,0,0,2.69,3.7,20.32,20.32,0,0,0,2.79,2.51C165.28,387.89,166.52,388.43,166.47,388.52Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMed);
export default __webpack_public_path__ + "static/media/Med.720d2decff642dc4797486b5311c1780.svg";
export { ForwardRef as ReactComponent };